import { useEffect } from 'react';

import { useMapStoreContext } from '@/microfrontends/map/shared/context/mapStoreContext';

export function useAttachBallonManager(balloonManager: YMaps.BalloonManager): void {
  const { map } = useMapStoreContext();

  useEffect(() => {
    map.geoObjects.add(balloonManager.objectManager);

    return (): void => {
      map.geoObjects.remove(balloonManager.objectManager);
    };
  }, [map.geoObjects, balloonManager.objectManager]);
}
